// saga 
export const FETCH_CUSTOMER_SOURCING_LANES = 'FETCH_CUSTOMER_SOURCING_LANES'
export const ADD_CUSTOMER_SOURCING_LANE = 'ADD_CUSTOMER_SOURCING_LANE'
export const DELETE_CUSTOMER_SOURCING_LANE = 'DELETE_CUSTOMER_SOURCING_LANE'

//reducer
export const SET_CUSTOMER_SOURCING_LANES = 'SET_CUSTOMER_SOURCING_LANES'
export const SET_SELECTED_CUSTOMER_SOURCING_LANE = 'SET_SELECTED_CUSTOMER_SOURCING_LANE'

export const SET_CUSTOMER_SOURCING_LANES_LOADING = 'SET_CUSTOMER_SOURCING_LANES_LOADING'
export const SET_CUSTOMER_SOURCING_LANES_ERROR = 'SET_CUSTOMER_SOURCING_LANES_ERROR'

export const UPSERT_CUSTOMER_SOURCING_LANE = 'UPSERT_CUSTOMER_SOURCING_LANE'
export const REMOVE_CUSTOMER_SOURCING_LANE = 'REMOVE_CUSTOMER_SOURCING_LANE'

export const SET_LANE_LOAD_STATS = 'SET_LANE_LOAD_STATS'

export const SET_LANE_OFFERS = 'SET_LANE_OFFERS'
export const ADD_LANE_OFFER = 'ADD_LANE_OFFER'
export const DELETE_LANE_OFFER = 'DELETE_LANE_OFFER'